import React from 'react';
import GroupsSection from '../components/GroupsSection';

const GroupsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <GroupsSection />
      </div>
    </div>
  );
};

export default GroupsPage;

